import { Direction } from "@/types/maze";
import { gsap } from "gsap";
import type * as PIXI from "pixi.js";

export function animatePlayerRoll(
  player: PIXI.Container,
  direction: Direction,
): void {
  const directionSign =
    direction === Direction.UP || direction === Direction.LEFT ? -1 : 1;

  gsap.fromTo(
    player,
    { rotation: -directionSign * 0.05 },
    {
      rotation: directionSign * 0.05,
      duration: 0.15,
      ease: "none",
      overwrite: "auto",
    },
  );
}
